import React, { forwardRef } from 'react';
import SearchIcon from 'assets/Icons/search';
import { IStaffItemData } from 'services/shop/types/staff';
import styled from 'styled-components';
import SelectedStaffChips from './selected-staff-chips';

type Props = React.HTMLAttributes<HTMLDivElement> & {
  staffs: IStaffItemData[];
  placeholder?: string;
  max?: number;
};

/**
 * Ô search giả — chỉ để nhìn và để bấm, không gõ được. Ô search thật nằm trong
 * popover, nhờ vậy click vào đây luôn là mở/đóng picker chứ không vướng vào
 * việc gõ phím. Khi đã chọn staff thì chips hiển thị ngay bên trong ô.
 *
 * forwardRef + spread rest props vì antd Popover gắn ref và tiêm onClick vào
 * phần tử trigger — không chuyển tiếp xuống DOM node thì bấm sẽ không mở.
 */
const StaffSearchTriggerBox = forwardRef<HTMLDivElement, Props>(
  ({ staffs, placeholder = 'Search by Staff’s Name', max = 3, ...rest }, ref) => (
    <Box ref={ref} {...rest}>
      <Content>
        {staffs.length ? (
          <SelectedStaffChips staffs={staffs} max={max} />
        ) : (
          <Placeholder>{placeholder}</Placeholder>
        )}
      </Content>
      <SuffixIcon>
        <SearchIcon fill='#fff' />
      </SuffixIcon>
    </Box>
  )
);

StaffSearchTriggerBox.displayName = 'StaffSearchTriggerBox';

export default StaffSearchTriggerBox;

/** Bám theo style của InputSearchSuffixIcon để trông y hệt ô search thật. */
const Box = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 56px;
  min-width: 400px;
  max-width: 560px;
  border: 3px solid #2d6772;
  border-radius: 100px;
  background: #fff;
  overflow: hidden;
`;

const Content = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0 12px 0 20px;
  overflow: hidden;
`;

const Placeholder = styled.div`
  color: #86909c;
  font-family: Poppins;
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const SuffixIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  width: 56px;
  height: 56px;
  justify-content: center;
  align-items: center;
  border-radius: 0px 100px 100px 0px;
  background: #2d6772;
`;
